/**
 * Environment provides the root api domain and the environment name the rest of the
 * UI. When making an api call it should look like the following:
 * ```
 * import { environment } from 'environment';
 * fetch(`https://${environment.apiRoot}/video/v1/accounts`);
 * ```
 * The environment defaults to the QA env and can be changed by the Kubical deployment service.
 * Any hardcoding of environment will cause issues with the UI and is not allowed.
 */
class Environment {
  envName;

  // Default to the QA environment
  constructor(apiRoot = "apix-qa.purecars.com", name = "qa") {
    this.envName = name;
    // Reset the window env for local development so that signal components
    // will correctly get the window.env object instead of `ENVIRONMENT_CONFIG_GOES_HERE`
    window.env = { apiRoot, envName: name };
  }

  get rootAPI() {
    return `https://apix${!this.isProduction ? "-qa" : ""}.purecars.com`;
  }

  get tradeAPIRoot() {
    return `${this.rootAPI}/trade/api`;
  }

  get leadsAPIRoot() {
    return `${this.rootAPI}/leads/leads`;
  }

  get isProduction() {
    return this.envName === "prod";
  }
}

export const environment = window.env
  ? new Environment(window.env.apiRoot, window.env.envName)
  : new Environment();

export default environment;

if (process.env.REACT_APP_LOCAL_API_SERVER === "true") {
  window.SignalDevAPIDomain.setTo({
    "/trade/api": "http://localhost:51793",
  });
  window.addEventListener("unload", () => window.SignalDevAPIDomain.reset());
}
